// plugin
import axios from 'axios';
import dayjs from 'dayjs'; //https://day.js.org/
import { Observable } from 'rxjs';
// helper
import ConfigManager from "@/config/ConfigManager.js";

/**
 * @method connectBzbsGet
 * @method connectBzbsDelete
 * @method connectBzbsPost
 * @method connectBzbsPostJson
 * @method connectBzbsPut
 * @method connectBzbsPutJson
 * @method connectBzbsGetBlob
 */
export default {
    /**
     * Connect Buzzebees GET method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @return Observable
     */
    connectBzbsGet: function (url, token, data, jwt) {
        let appId = ConfigManager.getAppId();
        return this.connectMethod(url, token, data, 'get', appId, jwt);
    },

    /**
     * Connect Buzzebees GET method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @param {string} appId (required)
     * @return {Observable}
     */
    connectBzbsGetWithAppId: function (url, token, data, appId, jwt) {
        return this.connectMethod(url, token, data, 'get', appId, jwt);
    },

    /**
     * Connect Buzzebees DELETe method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @return Observable
     */
    connectBzbsDelete: function (url, token, data, jwt) {
        let appId = ConfigManager.getAppId();
        return this.connectMethod(url, token, data, 'delete', appId, jwt);
    },

    /**
     * Connect Buzzebees DELETe method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @return {Observable}
     */
    connectBzbsDeleteWithAppId: function (url, token, data, appId, jwt) {
        return this.connectMethod(url, token, data, 'delete', appId, jwt);
    },

    /**
     * Connect Buzzebees POST method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     */
    connectBzbsPost: function (url, token, data, jwt) {
        let appId = ConfigManager.getAppId();
        return this.connectWithBody(url, token, data, 'post', appId, jwt);
    },
    connectBzbsRawPost: function (url, token, data, jwt) {
        let appId = ConfigManager.getAppId();
        return this.connectWithRawBody(url, token, data, 'post', appId, jwt);
    },
    /**
     * Connect Buzzebees POST method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     * @param {string} appId (required)
     * @return {Observable}
     */
    connectBzbsPostWithAppId: function (url, token, data, appId, jwt) {
        return this.connectWithBody(url, token, data, 'post', appId, jwt);
    },

    /**
     * Connect Buzzebees POST method with json body
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     * @param {string} uploadKey (optional)
     * @param {object} uploadfile (optional)
     */
     connectBzbsPostJson: function (url, token, data, jwt) {
        let appId = ConfigManager.getAppId();
        return this.connectMethodJson(url, token, data, 'post', appId, jwt);
    },

    /**
     * Connect Buzzebees PUT method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     * @param {string} uploadKey (optional)
     * @param {object} uploadfile (optional)
     */
    connectBzbsPut: function (url, token, data, jwt) {
        let appId = ConfigManager.getAppId();
        return this.connectWithBody(url, token, data, 'put', appId, jwt);
    },

    /**
     * Connect Buzzebees PUT method with json body
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     * @param {string} uploadKey (optional)
     * @param {object} uploadfile (optional)
     */
    connectBzbsPutJson: function (url, token, data, jwt) {
        let appId = ConfigManager.getAppId();
        return this.connectMethodJson(url, token, data, 'put', appId, jwt);
    },

    /**
     * Connect Buzzebees with Method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     * @param {string} uploadKey (optional)
     * @param {object} uploadfile (optional)
     * @param {string} method post, put
     */
    connectWithBody: function (url, token, data, method, appId, jwt) {
        return new Observable((subscriber) => {
            var header = {}

            if(appId){
                header['App-Id'] = appId
            }
            // data.device_app_id = this.config().client_id;
            var form = this.arrToFormData(data);

            if (token != null) {
                header.Authorization = 'token ' + token;
            }
            else if (jwt != null) {
                header.Authorization = 'Bearer ' + jwt;
            }

            axios({
                method: method,
                url: url,
                data: form,
                headers: header,
            }).then((res) => {
                // subscriber.next(res);
                var data = this.convertResponse(res);

                if (data.isError) {
                    subscriber.error(this.setErrorObjStatus200(res));
                } else {
                    subscriber.next(res);
                }
            }).catch((err) => {
                subscriber.error(this.setErrorObj(err));
            });
        });
    },

    connectWithRawBody: function (url, token, data, method, appId, jwt) {
        return new Observable((subscriber) => {
            var header = {}

            if(appId){
                header['App-Id'] = appId
                header['Content-Type'] = 'application/json'
                // header['Content-Type'] = 'text/plain'
            }
            // data.device_app_id = this.config().client_id;
            if (data == null) {
                data = {};
            }
            
            var form = data;
            if (token != null) {
                header.Authorization = 'token ' + token;
            }
            else if (jwt != null) {
                header.Authorization = 'Bearer ' + jwt;
            }
            
            axios({
                method: method,
                url: url,
                data: form,
                headers: header,
            }).then((res) => {
                // subscriber.next(res);
                var data = this.convertResponse(res);

                if (data.isError) {
                    subscriber.error(this.setErrorObjStatus200(res));
                } else {
                    subscriber.next(res);
                }
            }).catch((err) => {
                subscriber.error(this.setErrorObj(err));
            });
        });
    },

    /**
     * Connect Buzzebees with Method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @param {string} method (required) get, delete
     * @return Observable
     */
    connectMethod: function (url, token, data, method, appId, jwt) {
        return new Observable((subscriber) => {
            var header = {
                'App-Id': appId,
            };
            if (data == null) {
                data = {};
            }
            if (token != null) {
                header.Authorization = 'token ' + token;
            }
            else if (jwt != null) { 
                header.Authorization = 'Bearer ' + jwt;
            }
            axios({
                method: method,
                url: url,
                params: data,
                headers: header,
            }).then((res) => {
                var data = this.convertResponse(res);

                if (data.isError) {
                    subscriber.error(this.setErrorObjStatus200(res));
                } else {
                    subscriber.next(res);
                }
            }).catch((err) => {
                subscriber.error(this.setErrorObj(err));
            });
        });
    },

    /**
     * Connect Buzzebees with Method json body
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @param {string} method (required) post, put
     * @return Observable
     */
    connectMethodJson: function (url, token, data, method, appId, jwt) {
        return new Observable((subscriber) => {
            var header = {
                'App-Id': appId,
            };
            if (data == null) {
                data = {};
            }
            if (token != null) {
                header.Authorization = 'token ' + token;
            }
            else if (jwt != null) { 
                header.Authorization = 'Bearer ' + jwt;
            }
            axios({
                method: method,
                url: url,
                data: data,
                headers: header,
            }).then((res) => {
                var data = this.convertResponse(res);

                if (data.isError) {
                    subscriber.error(this.setErrorObjStatus200(res));
                } else {
                    subscriber.next(res);
                }
            }).catch((err) => {
                subscriber.error(this.setErrorObj(err));
            });
        });
    },

    setErrorObjStatus200: function (res) {
        var error = {
            error: res,
            id: null,
        };
        if (res != null && res.data != null && res.data.error != null) {
            error = {
                id: res.data.error.id,
                code: res.data.error.code,
                message: res.data.error.message,
                type: res.data.error.type,
            };
        } else if (res != null && res.data != null) {
            error = {
                id: null,
                code: res.data.code,
                message: res.data.message,
            };
        }
        return error;
    },

    setErrorObj: function (err) {
        var error = {
            error: err,
            id: null,
        };
        if (err.response
            && err.response.data
            && err.response.data.error) {
            error = {
                id: err.response.data.error.id,
                code: err.response.data.error.code,
                message: err.response.data.error.message,
                type: err.response.data.error.type
            };
        } else {
            error = {
                id: err.response?.id,
                code: err.response?.code,
                message: err.response?.message,
                type: ''
            };
        }
        error.err = err; // for log
        
        return error;
    },

    /**
     * Convert data to array of FormData
     * @param {Array|Dictionary} arr
     */
    arrToFormData: function (arr) {
        var form = new FormData();
        for (var i in arr) {
            form.append(i, arr[i]);
        }
        return form;
    },

    /**
     * Connect Buzzebees GET Blob
     * @param {string} url string url
     * @return Promise
     */
    connectBzbsGetBlob: function (url) {
        return new Observable((subscriber) => {
            const timestamp = dayjs().unix();
            url += `?t=${timestamp}`;

            axios({
                method: 'get',
                url: url,
            }).then((res) => {
                subscriber.next(res);
            }).catch((err) => {
                subscriber.error(this.setErrorObj(err));
            });
        });
    },

    convertResponse: function (res) {
        var data = res.data;
        if (data.success === true || data.success === false) {
            return {
                isError: data.success ? false : true,
                data: data,
            };
        } else {
            return {
                isError: false,
                data: data,
            };
        }
    },
}
